const heroImage = "/hero-welding-bg.webp";
import { useLanguage } from "@/contexts/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-surface-dark">
      <div className="absolute inset-0">
        <img src={heroImage} alt="Resistance welding process" width={1400} height={800} className="w-full h-full object-cover" loading="eager" decoding="async" fetchPriority="high" />
        <div className="absolute inset-0 bg-gradient-to-r from-surface-dark/80 via-surface-dark/50 to-transparent" />
        <div className="absolute inset-0 backdrop-blur-sm" style={{ maskImage: 'linear-gradient(to right, transparent 40%, rgba(0,0,0,0.52) 80%)', WebkitMaskImage: 'linear-gradient(to right, transparent 40%, rgba(0,0,0,0.52) 80%)' }} />
      </div>

      <div className="container relative z-10 pt-20">
        <div className="max-w-3xl">
          <p className="text-sm font-medium tracking-[0.2em] uppercase text-highlight mb-6 animate-fade-up">
            {t.heroEyebrow}
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-surface-dark-foreground leading-[1.1] mb-6 animate-fade-up" style={{ animationDelay: "0.1s" }}>
            {t.heroTitle1}
            <span className="text-highlight">{t.heroTitleHighlight}</span>
          </h1>
          <p className="text-lg md:text-xl text-surface-dark-foreground/70 max-w-2xl mb-10 animate-fade-up" style={{ animationDelay: "0.2s" }}>
            {t.heroSub}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-up" style={{ animationDelay: "0.3s" }}>
            <a href="#contact" className="inline-flex items-center justify-center px-8 py-3.5 text-base font-semibold bg-primary text-primary-foreground rounded hover:bg-highlight-glow transition-colors">
              {t.sendInquiry}
            </a>
            <a href="#solutions" className="inline-flex items-center justify-center px-8 py-3.5 text-base font-semibold border border-surface-dark-foreground/30 text-surface-dark-foreground rounded hover:border-surface-dark-foreground/60 transition-colors">
              {t.viewSolutions}
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-highlight via-highlight-glow to-transparent" />
    </section>
  );
};

export default Hero;
